import { connect, useDispatch } from 'react-redux';
import { DatePicker } from 'react-widgets'
import { medicalRxsLoad, medicalRxUpdate, medicalRxDelete, medicalRxSecureFax, medicalRxPrint } from '../../../../redux/actions/medicalRxActions'
import MedicalRxReportTemplate from '../../../../itrust_common/containers/authorised/setting/patient/report/reportTypes/ReportTemplate';
import Alert from '../../../../itrust_common/components/Alert'
import SecureFaxForm from '../../secureFax/SecureFaxForm';
import { maskDateInput } from '../../../../itrust_common/components/HelperFunctions'
import { useEffect } from 'react';

function MedicalRxView(props) {
  const { medicalRxes, patientId, pprops, pprops: { patientReport }, dateFormatType,currentStore ,currentUser} = props
  const dispatch = useDispatch()

  useEffect(() => {
    handleMedicalRxsLoad({ examination_id: pprops.initialValues.id, rpp: 999999 })
  }, [])

  const handleMedicalRxsLoad = (filters) => {
    dispatch(medicalRxsLoad(patientId, filters))
  }

  const handleMedicalRxSubmit = (data) => {
    dispatch(medicalRxUpdate(patientId, data))
  }

  const handleMedicalRxDelete = (id) => {
    Alert.deleteConfirm(
      "Are you sure? You want to delete this record.",
      (response) => {
        if (response)
          dispatch(medicalRxDelete(patientId, id))
      }
    )
  }

  const handleMedicalRxSecureFax = (data) => {
    dispatch(medicalRxSecureFax(patientId, data))
  }

  const handlePrintMedicalRx = async (patient_id, medical_rx_id) => {
    let res = await dispatch(medicalRxPrint({ patient_id, id: medical_rx_id }))
    window.open(res.value.data.filepath, '_blank')
  }
    const canEscribe =
   currentStore?.store?.permissions?.find(
    (permission) => permission.app_module_name === 'exams'
   )?.permissions?.can_ePrescribe === true;
  return (
    <>
      {medicalRxes.map((rx, index) =>
        <div className="col-6 mb-7 medicalRx-scrollIntoView" id={`MedicalRx-${rx.id}`}>
          {!(currentUser.role === 'non_admin' && !canEscribe) && (
          <div className="bg-white">
            <div className="d-flex align-items-center justify-content-between p-5 border-bottom border-bottom-2 border-light" >
              <h6>Medical Rx #{index + 1}</h6>
              <div className="w-75 d-flex align-items-center">
                <SecureFaxForm label="e-SCRIBE to Contact" form={`secureFaxForm-${rx.id}`} onSubmit={handleMedicalRxSecureFax} initialValues={{ id: rx.id }} />
                {/* <ExportButton label="Print" className="btn btn-primary mx-5" path={`/v1/patients/${patientId}/medical_rxes/${rx.id}/download_pdf`} /> */}
                <button type="button" className="btn btn-danger mx-5" onClick={() => handlePrintMedicalRx(patientId, rx.id)}>Print</button>
                <button type="button" className="btn btn-danger" onClick={() => handleMedicalRxDelete(rx.id)}>Remove</button>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between p-5 border-bottom border-bottom-2 border-light" >
              <div className="d-flex  align-items-center">
                <span className="mr-5">Issue Date</span>
                <DatePicker
                  defaultValue={rx.issue_date && new Date(rx.issue_date.replace(/-/g, '\/'))}
                  format={dateFormatType}
                  editFormat={dateFormatType}
                  placeholder={dateFormatType}
                  onChange={(date) => handleMedicalRxSubmit({ id: rx.id, issue_date: date })}
                  onKeyDown={e => e.keyCode === 191 && e.preventDefault()}
                  onKeyUp={e => maskDateInput(e)}
                />
              </div>
              <div className="d-flex  align-items-center">
                <span className="mr-5">Expiry Date</span>
                <DatePicker
                  defaultValue={rx.expiry_date && new Date(rx.expiry_date.replace(/-/g, '\/'))}
                  format={dateFormatType}
                  editFormat={dateFormatType}
                  placeholder={dateFormatType}
                  onChange={(date) => handleMedicalRxSubmit({ id: rx.id, expiry_date: date })}
                  onKeyDown={e => e.keyCode === 191 && e.preventDefault()}
                  onKeyUp={e => maskDateInput(e)}
                />
              </div>
            </div>
            <div className="p-7">
              <div className="border">
                {patientReport && <MedicalRxReportTemplate displayFields={patientReport?.display_fields} displayValues={patientReport?.display_values} reportData={rx} category="medical_rx">
                  <div className="medical-rx d-flex flex-column justify-content-between py-6">
                    <div className="">
                      <div className="pb-4">{rx.medication}</div>
                      <div className="pt-4">Sig: {rx.dosage}</div>
                    </div>
                    {rx.is_refil_required !== true && <div className="pb-9">
                      <h6 className="pb-4">Comment: <span className="border-bottom border-bottom-2 border-secondary px-4 font-weight-normal">{rx.comments}</span></h6>
                      <h6 className="pb-4">Refill: <span className="border-bottom border-bottom-2 border-secondary px-4 font-weight-normal">{rx.refil_value}</span> times</h6>
                      <h6 className="pt-4">Generic: <span className="border-bottom border-bottom-2 border-secondary px-4 font-weight-normal">{rx.is_generic ? "Yes" : "No"}</span></h6>
                    </div>}
                  </div>
                </MedicalRxReportTemplate>}
              </div>
            </div>
          </div>
      )}
      </div>
      )}
    </>
  )
}

const mapStateToProps = state => {
  const { medicalRx, organisation: { organisation },currentStore,auth } = state;
  return {
    medicalRxes: medicalRx.medical_rxes,
    medicalRxEditing: medicalRx.editing,
    currentUser: auth.user,
    dateFormatType: organisation.preferences?.date_format,
    currentStore
  }
}

export default connect(mapStateToProps)(MedicalRxView);